import { RootStore } from '@/store/rootStore'
import { Module } from 'vuex'

export const token: Module<any, RootStore> = {
  namespaced: true,
  state: {
    tokenInfo: null
  },
  mutations: {
    setTokenInfo (state, param) {
      state.tokenInfo = param
    }
  },
  actions: {
    setTokenInfo ({ commit }, param) {
      commit('setTokenInfo', param)
    }
  },
  getters: {
    TokenInfo (state) {
      return state.tokenInfo
    }
  }
}
